import { ExportTemplateFormValue } from '../services/export-template-api.service';

export const saveTemplate = {
  /**
   * Multipart body shared by add_template and edit_template; the id is mandatory on
   * edit and unused on create.
   *
   * Optional fields are *omitted* rather than sent empty - the backend treats an
   * absent `file_path` as "keep the current file" - and `companies` goes out as
   * repeated `companies[]` entries. Content-Type is deliberately not set, so
   * HttpClient adds the multipart boundary itself.
   */
  toMultipartFormData(
    template: ExportTemplateFormValue,
    id?: string | number | null,
  ): FormData {
    const formData = new FormData();

    if (id) {
      formData.append('id', String(id));
    }

    formData.append('name', template.name);
    formData.append('language_id', String(template.language_id));
    formData.append('output_format_id', String(template.output_format_id));

    if (template.html_template_file_path) {
      formData.append(
        'html_template_file_path',
        template.html_template_file_path,
      );
    }

    if (template.is_default !== undefined && template.is_default !== null) {
      formData.append('is_default', String(template.is_default));
    }

    if (template.file_path instanceof File) {
      formData.append('file_path', template.file_path, template.file_path.name);
    }

    if (template.companies) {
      template.companies.forEach((company) => {
        formData.append('companies[]', company);
      });
    }

    return formData;
  },
};
